<template>
    <div class="resort__calculator">
        <div class="resort__calculator-loader" v-bind:class="{ 'hidden': !$store.state.loader }">
            <div class="resort__calculator-loader-inner">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="resort__calculator-fields">
            <div class="resort__calculator-row">
                <div class="resort__calculator-field">
                    <select name="resort" v-model="$store.state.selections.resort" v-on:change="clear( 'type|view' )" class="resort__calculator-field-input">
                        <option value="">-- Choose a Resort --</option>
                        <option v-for="resort in $store.state.resorts" v-bind:key="resort.id" v-bind:value="resort.id" v-html="resort.title"></option>
                    </select>
                    <label class="resort__calculator-field-label">Resort</label>
                </div>
                <div class="resort__calculator-field">
                    <select name="room_type" v-model="$store.state.selections.type" v-on:change="clear( 'view' )" class="resort__calculator-field-input" v-bind:disabled="!( $store.state.selections.resort )">
                        <option value="">-- Choose a Room Type --</option>
                        <option v-for="room_type in get_resort_room_data( 'rooms' )" v-bind:key="room_type.id" v-bind:value="room_type.id" v-html="room_type.name"></option>
                    </select>
                    <label class="resort__calculator-field-label">Room Type</label>
                </div>
                <div class="resort__calculator-field">
                    <select name="room_view" v-model="$store.state.selections.view" class="resort__calculator-field-input" v-bind:disabled="!( ( $store.state.selections.type ) && ( $store.state.selections.resort ) )">
                        <option value="">-- Choose a Room View --</option>
                        <option v-for="room_view in get_resort_room_data( 'views' )" v-bind:key="room_view.key" v-bind:value="room_view.id" v-html="room_view.name"></option>
                    </select>
                    <label class="resort__calculator-field-label">Room View</label>
                </div>
            </div>
            <div class="resort__calculator-row">
                <div class="resort__calculator-field resort__calculator-field--date">
                    <functional-calendar ref="calendar"
                                         :sunday-start="true"
                                         :date-format="'yyyy-mm-dd'"
                                         :min-sel-days="2"
                                         :is-separately="false"
                                         :is-date-range="true"
                                         :is-multiple="true"
                                         :calendars-count="2"
                                         :is-modal="false"
                                         :transition="true"
                                         :disabled-dates="[ 'beforeToday' ]"
                                         v-on:choseDay="handle_date_select" />
                </div>
                <div class="resort__calculator-field resort__calculator-field--button">
                    <button type="button" class="btn btn-primary" v-on:click="$store.dispatch( 'calculate' );" v-bind:disabled="!( ( $store.state.selections.start ) && ( $store.state.selections.end ) && ( $store.state.selections.type ) && ( $store.state.selections.view ) && ( $store.state.selections.resort ) )">Calculate</button>
                </div>
            </div>
        </div>

        <div class="resort__calculator-results" v-if="$store.state.results.total">
            
            

            <div class="resort__calculator-results-lines">
                <table class="resort__calculator-results-lines-table">
                    <thead>
                        <tr>
                            <th class="heading-date">Date</th>
                            <th class="heading-tier">Tier</th>
                            <th class="heading-cost">Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in $store.state.results.schedule" v-bind:key="row.date" v-bind:class="'tier-' + row.tier">
                            <td class="value-date">{{ row.date }}</td>
                            <td class="value-tier">
                                <span class="value-tier__id">{{ row.tier }}</span>
                                <span class="value-tier__days">({{ row.tier_day_start }}-{{ row.tier_day_end }})</span>
                            </td>
                            <td class="value-cost">{{ row.cost }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="resort__calculator-results-totals">
                <span>For this stay, you'll need</span>
                <strong>{{ $store.state.results.total }}</strong>
                <span>points</span>
            </div>
        </div>

        <div class="resort__calculator-actions" v-if="$store.state.results.total">

        </div>
    </div>
</template>

<script>
    import { FunctionalCalendar } from 'vue-functional-calendar';

    export default {
        name: 'DVCAPointCalculator',

        components: {
            FunctionalCalendar
        },

        mounted: function() {
            this.$store.dispatch( 'initialize' );
        },

        methods: {
            clear: function( types ) {
                let values = types.split( '|' );

                if ( ( values ) && ( values.length ) ) {
                    for ( let counter = 0; counter < values.length; counter++ ) {
                        this.$store.commit( 'set_value', { collection: 'selections', attribute: values[ counter ], data: '' } );
                    }
                }
            },

            get_resort_room_data: function( type ) {
                if ( this.$store.state.selections.resort ) {
                    for ( let counter = 0; counter < this.$store.state.resorts.length; counter++ ) {
                        if ( this.$store.state.resorts[ counter ].id === this.$store.state.selections.resort ) {
                            if ( type === 'rooms' ) {
                                return this.$store.state.resorts[ counter ].room_types;
                            } else if ( ( type === 'views' ) && ( this.$store.state.selections.type ) ) {
                                for ( let room_type in this.$store.state.resorts[ counter ].room_types ) {
                                    if ( this.$store.state.resorts[ counter ].room_types[ room_type ].id === this.$store.state.selections.type ) {
                                        return this.$store.state.resorts[ counter ].room_types[ room_type ].views;
                                    }
                                }
                            }
                        }
                    }
                }

                return false;
            },

            handle_date_select: function () {
                if ( this.$refs.calendar._data.calendar.dateRange.start ) {
                    this.$store.commit( 'set_value', { collection: 'selections', attribute: 'start', data: this.$refs.calendar._data.calendar.dateRange.start } );
                    this.$store.commit( 'set_value', { collection: 'selections', attribute: 'end', data: null } );
                }

                if ( this.$refs.calendar._data.calendar.dateRange.end ) {
                    this.$store.commit( 'set_value', { collection: 'selections', attribute: 'end', data: this.$refs.calendar._data.calendar.dateRange.end } );
                }
            }
        }
    };
</script>